var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckMark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#99BA14",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5.025c.552 0 1 .448 1 1v10h-2v-10c0-.552.448-1 1-1z",
    transform: "rotate(45 9.145 7.68)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.293v2h-6c-.552 0-1-.448-1-1s.448-1 1-1h6z",
    transform: "rotate(45 9.145 7.68)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckMark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkMark.5c686269c9d4a7d1d90d80f8d94dbb5a.svg";